import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['element']

  destroy(_event) {
    this.elementTarget.parentNode.removeChild(this.elementTarget)
  }
}
